import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { InstagramState } from 'apps/instagram/models/interfaces'
import { settingsApi } from 'shared/api/requests/settings'
import { createAsyncAction } from 'shared/lib/redux'

export const toggleInstagramChannel = createAsyncAction(
  'instagram/toggleChannelRequest',
  async (value: boolean) => {
    await settingsApi.toggleInstagramChannel({ body: { value } })
    return value
  },
)

export const toggleInstagramChannelReducer = (builder: ActionReducerMapBuilder<InstagramState>) => {
  builder.addCase(toggleInstagramChannel.pending, (state) => {
    state.toggleChannelFetching = true
  })
  builder.addCase(toggleInstagramChannel.fulfilled, (state) => {
    state.toggleChannelFetching = false
  })
  builder.addCase(toggleInstagramChannel.rejected, (state) => {
    state.toggleChannelFetching = false
  })
}
